import { Link } from 'react-router-dom'

import NotFoundPic from '../../../images/not-found.png'
import Logo from '../../logo'

import styles from './styles.module.scss'

const NotFound = () => {
  return (
    <div className={styles.main}>
      <div className={styles.logo}>
        <Logo isBlack={true} />
      </div>
      <img className={styles.image} src={NotFoundPic} />
      <p className={styles.title}>Страница не найдена</p>
      <p className={styles.text}>
        Эта страница не найдена. Возможно она удалена или введен неверный адрес
      </p>
      <p className={styles.text}>Код ошибки: 400</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link to={'/service'}>Сервисы</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/upload'}>Загрузка данных</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/settings'}>Настройки</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/knowledge'}>База знаний</Link>
        </li>
      </ul>
    </div>
  )
}

export default NotFound
